<template>
  <div class="panel-body">
      <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <VueFormGenerator :schema="schema" :model="model" :options="formOptions"></VueFormGenerator>
    <p v-if="sent">{{msg_conferma}}</p>
  <div role="tablist" v-if="!sent && !errorload.length">
      <div v-for="d in filteredData" v-bind:key="d.name">
      <b-card no-body class="mb-1" v-if="d.name">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#" v-b-toggle="'accordion-' + d.id" variant="info">Delivery {{d.name}}</b-button>
        </b-card-header>
        <b-collapse :id="'accordion-' + d.id" :visible="true" accordion="my-accordion" role="tabpanel" ref="id">
          <b-card-body>
              <vue-form-generator :model="model" :schema="schema_2" :options="formOptions"></vue-form-generator>
              <button @click="nextStep(d.id)">Salva</button>
              <p v-if="msg_delivery_record">{{msg_delivery_record}}</p>
          </b-card-body>
        </b-collapse>
      </b-card>
      </div>
      </div>    
    <button v-if="this.fetched" @click="sendData()">Registra consegne e contributi</button>
      <p v-if="!sent">{{this.msg_conferma}}</p>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'conferimento',
  components: {
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      config: {headers: { Authorization: 'bearer ' + localStorage.getItem('access_token') }},
      loading: false,
      counter: 0,
      fetched: false,
      sent: false,
      consegne: [],
      list: [],
      batch_created: false,
      msg_conferma: '',
      msg_delivery_record: '',
      skipped_lines: '',
      total_rows: 0,
      inserted_rows: 0,
      model: {
        create_message: '',
        batchraws_date: Date,
        batchraws_code: '',
        dati: '',
        trasporto: {
        },
        pasteurizaton:{
        }
        },
      schema: {
        fields: [
          {
            type: 'input',
            inputType: 'date',
            label: 'Data di creazione lotto MP',
            model: 'batchraws_date',
            disabled: false
          },
          {
            type: 'input',
            inputType: 'string',
            label: 'Codice del lotto',
            model: 'batchraws_code',
            disabled: false,
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Crea Lotto',
            validateBeforeSubmit: true,
            onSubmit: this.saveForm,
            disabled: false
          },
          {
            type: 'submit',
            buttonText: 'Cancella Lotto',
            validateBeforeSubmit: true,
            onSubmit: this.deleteBatch,
            disabled: false
          },
          {
            type: 'label',
            label: '',
            model: 'create_message'
          },          
          {
            type: "file",
            label: "Caricamento file Excel",
            model: "dati",
          }
        ]
      },
      schema_2: {
        fields: [
          {
            type: 'input',
            inputType: 'time',
            label: 'Ora inizio trasporto del Lotto',
            model: 'trasporto.start'
          },
          {
            type: 'input',
            inputType: 'time',
            label: 'Ora fine trasporto del Lotto',
            model: 'trasporto.end'
          },
          {
            type: 'input',
            inputType: 'time',
            label: 'Ora inizio pastorizzazione',
            model: 'pasteurizaton.start',
          }
          ,
          {
            type: 'input',
            inputType: 'time',
            label: 'Ora fine pastorizzazione',
            model: 'pasteurizaton.end',
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  methods: {
    clicker: function () {
      this.counter = this.counter + 1
    },
    deleteBatch: function (model) {
      this.loading = true
      axios.get(this.apiUrl + 'batchraws?code=' + model['batchraws_code'], this.config).then((response) => {
                  if (response.data.length === 0) {
            model.create_message = 'Lotto non trovato, inserire un codice valido'
          }
          else if (response.data[0].notarization_status === 'complete') {
            model.create_message = 'Lotto già notarizzato, impossibile eliminare'
          }
          else {
      axios.delete(this.apiUrl + 'batchraws/' + response.data[0].id, this.config)
        .then(() => {
          model.create_message = 'Lotto eliminato correttamente'
          this.batch_created = false
          this.schema.fields[0].disabled = false
          this.schema.fields[1].disabled = false
          this.schema.fields[2].disabled = false

        }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      model.create_message = 'Si è verificato un errore, riprovare'
      })
      }})
      .finally(() => {
      this.loading = false
    })
    },
    saveForm: function (model) {
      this.loading = true
      axios.get(this.apiUrl + 'batchraws?code=' + model['batchraws_code'], this.config)
        .then((response) => {
          // eslint-disable-next-line
          // console.log(response.data)
          if (response.data.length === 0) {
      axios.post(this.apiUrl + 'batchraws', { 'code': model['batchraws_code'] }, this.config)
        .then(response => {
      this.$store.dispatch('update_conferimento', { 'code': model['batchraws_code'], 'batchraw': response.data.id })
      model.create_message = 'Lotto creato correttamente'
      this.batch_created = true
      this.schema.fields[0].disabled = true
      this.schema.fields[1].disabled = true
      this.schema.fields[2].disabled = true
        })}
      else if (response.data[0].deliveries.length === 0) {
        model.create_message = 'Lotto già esistente ma senza consegne, puoi procedere con l\'inserimento delle consegne'
      this.$store.dispatch('update_conferimento', { 'code': model['batchraws_code'], 'batchraw': response.data.id })
      this.schema.fields[0].disabled = true
      this.schema.fields[1].disabled = true
      this.schema.fields[2].disabled = true
      }
    else {
    model.create_message = 'Il lotto inserito esiste già, cambiare il codice'
    }}).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      model.create_message = 'Si è verificato un errore, riprovare'
      }).finally(() => {
      this.loading = false
    })
    },
    nextStep: function (id) {
      if (!this.model.trasporto.start || !this.model.trasporto.end || !this.model.pasteurizaton.start || !this.model.pasteurizaton.end) {
        this.msg_delivery_record = 'Compila tutti i campi e riprova'
      }
      else {
      try {
      this.msg_delivery_record = ''
      var object = {
        'carrier': id,
        'start': this.model.trasporto.start,
        'end': this.model.trasporto.end,
        "pasteurization_start": this.model.pasteurizaton.start,
        "pasteurization_end":this.model.pasteurizaton.end
        }
      this.consegne.push(object)
      var refresh = this.$refs.id[+ this.counter].$el.id
      this.$root.$emit('bv::toggle::collapse', refresh)
      this.clicker()
      var next = this.$refs.id[+ this.counter].$el.id
      this.$root.$emit('bv::toggle::collapse', next)
      this.model.trasporto.start = ''
      this.model.trasporto.end = ''
      this.model.pasteurizaton.start = ''
      this.model.pasteurizaton.end = ''
      }
      catch (e) {
        // eslint-disable-next-line
        console.log(e)
        // console.log("Terminato l'inserimento")
        this.fetched = true
      }
      }
    },
    sendData: function () {
      if (this.batch_created) {
      this.loading = true
      // this.$store.dispatch('update_delivery', this.consegne)
      var deliveries = this.consegne
      // console.log(deliveries)
      var converted_date = new Date(this.model.batchraws_date)
      
      var year = converted_date.getFullYear()
      var month = ("0" + (converted_date.getMonth() + 1)).slice(-2)
      var day = ("0" + (converted_date.getDate())).slice(-2)
      this.total_rows = this.$store.getters.LOADEDDATA_GET.length
      for (var d in deliveries) {
        let delivery_item = deliveries[d]
        // console.log("item ", delivery_item)
        let start = year + "-" + month + "-" + day + " " + delivery_item.start + ":00"
        let end = year + "-" + month + "-" + day + " " + delivery_item.end + ":00"
        let start_p = year + "-" + month + "-" + day + " " + delivery_item.pasteurization_start + ":00"
        let end_p = year + "-" + month + "-" + day + " " + delivery_item.pasteurization_end + ":00"
        // console.log(delivery_item.carrier, start, end)
      // TODO: verificare appena Andrea crea i campi come passargli i due valori nuovi
      axios.post(this.apiUrl + 'deliveries', { 'batchraw': this.$store.getters.BATCHRAW_GET, 'carrier': delivery_item.carrier, 'start': start, 'end': end, 'start_pasteurization': start_p, 'end_pasteurization': end_p }, this.config)
        .then(response => {
        // console.log("response ", response.data)
          this.list.push({ 'batchraw': this.$store.getters.BATCHRAW_GET, 'id': response.data.id, 'carrier': response.data.carrier }) 
      // console.log("deliveries: ", list)
          let farmerbatches = this.$store.getters.LOADEDDATA_GET
      // console.log(farmerbatches)
      // eslint-disable-next-line
      for (var fb in farmerbatches) {
      var item = farmerbatches[fb]
           let milked
          if (typeof item.TRASP !== 'undefined') {
          // console.log(item.TRASP.id, "against ", response.data.carrier.id)
          if (item.TRASP.id === response.data.carrier.id) {
            item.delivery = response.data.id
            // eslint-disable-next-line
            // console.log(item)
          milked = item.TRASP.milked
        axios.post(this.apiUrl + 'farmerbatches', 
        {
            "quantity": item.CFTQTACONF,
            "farmer": item.id,
            "delivery": item.delivery,
            "milked": milked,
            "percentage": item.percentage
        }, this.config)
        .then(() => {
          // eslint-disable-next-line
         //console.log("Response ", response.data)
         this.inserted_rows++
          if (this.total_rows === this.inserted_rows) {
              this.msg_conferma = 'Informazioni inserite correttamente'
              this.fetched = false
              this.sent = true
              this.loading = false
          }
        })            
          }
          }
          else {
          item.delivery = null
          milked = null
          }
          }
      // this.$store.dispatch('update_conferimento', [])
      // this.$store.dispatch('update_excel', [])
    }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      this.msg_conferma = 'Si è verificato un errore, riprova'
      })
      }
      }
      else {
      this.msg_conferma = 'Devi prima creare il lotto per poter procedere, premi il tasto Crea Lotto'  
      }
    },
    setBatchCode: function () {
      var codiceprodotto
      const toTwoDigits = num => num < 10 ? '0' + num : num
      let today = new Date
      // console.log(today)
      // console.log(typeof(today)) 
      this.model.batchraws_date = today.getTime()
      // eslint-disable-next-line 
      let year = today.getFullYear()
      // eslint-disable-next-line 
      //console.log(year)
      let month = toTwoDigits(today.getMonth() + 1)
      // eslint-disable-next-line 
      //console.log(month)
      let day = toTwoDigits(today.getDate())
      // eslint-disable-next-line 
      //console.log(day)
      codiceprodotto = 'MP' + day + month + year;
      // eslint-disable-next-line
      //console.log("codice prodotto " + codiceprodotto);
      this.model.batchraws_code = codiceprodotto
    },
      unsetContributes: function () {
      this.$store.dispatch('update_excel', [])
      }
  },
  watch: {
      currentdate: function () {
      var codiceprodotto
      const toTwoDigits = num => num < 10 ? '0' + num : num
      let today = new Date(this.model.batchraws_date)
      // eslint-disable-next-line 
      let year = today.getFullYear()
      // eslint-disable-next-line 
      //console.log(year)
      let month = toTwoDigits(today.getMonth() + 1)
      // eslint-disable-next-line 
      //console.log(month)
      let day = toTwoDigits(today.getDate())
      // eslint-disable-next-line 
      //console.log(day)
      codiceprodotto = 'MP' + day + month + year;
      // eslint-disable-next-line
      //console.log("codice prodotto " + codiceprodotto);
      this.model.batchraws_code = codiceprodotto        
      }
  },
  computed: {
      errorload: function () {
        return this.$store.getters.ERRORLOADING_GET
      },
      currentdate: function () {
        return this.model.batchraws_date
      },
      loadedData: function () {
        return this.$store.getters.LOADEDDATA_GET
      },
      filteredData: function () {
      var uniqueNames = [];
      var key = []
      for(var i = 0; i< this.loadedData.length; i++){    
      if((this.loadedData[i].TRASP) && (key.indexOf(this.loadedData[i].TRASP.name) === -1)){
      key.push(this.loadedData[i].TRASP.name)
      uniqueNames.push({'name':this.loadedData[i].TRASP.name,'id':this.loadedData[i].TRASP.id})}         
      }     
      // eslint-disable-next-line
      // console.log(uniqueNames)
      return uniqueNames    
      }
  },
  mounted () {
    this.unsetContributes()
    this.setBatchCode()
  }
}  
</script>

<style>
</style>